import { useQuery, keepPreviousData as previousPlaceholder } from '@tanstack/react-query';
import isArray from 'lodash-es/isArray';

import { ApiAuthorsResponse } from '../lib/api/Authors';

import { useApi } from '../contexts/ApiContext';

type UseAuthorsOptions = Omit<
    Parameters<typeof useQuery<ApiAuthorsResponse>>[0],
    'queryKey' | 'queryFn'
> & {
    keepPreviousData?: boolean;
};

export default function useAuthors(query = null, opts: UseAuthorsOptions = {}) {
    const api = useApi();
    const { keepPreviousData = true, ...otherOpts } = opts || {};
    const { data = null, ...queryResult } = useQuery<ApiAuthorsResponse>({
        queryKey: ['authors', query],
        queryFn: ({ queryKey: [, queryParam], signal }) =>
            api.authors.get(queryParam, null, null, { signal }),
        placeholderData: keepPreviousData ? previousPlaceholder : null,
        ...otherOpts,
    });

    const { data: items = null, ...metadata } = isArray(data) ? { data } : data || {};

    return data !== null
        ? {
              items,
              ...metadata,
              ...queryResult,
          }
        : queryResult;
}
